<template>
  <header class="app-header">
    <span class="logo">TODOS</span>
  </header>
</template>
